module.exports = __webpack_public_path__ + "static/media/care-advocate-myra.9328a684.png";